import * as React from 'react'

const SvgLocked = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.014 9.707V6.112C17.014 3.29 14.772 1 12.005 1 9.24 1 6.996 3.289 6.996 6.112v3.595C4.74 9.875 2.994 11.796 3 14.105v5.497C3 22.032 4.93 24 7.309 24h9.382C19.071 24 21 22.031 21 19.602v-5.497c.006-2.305-1.733-4.225-3.986-4.398zM12.006 2.65c1.875 0 3.398 1.549 3.403 3.463v3.563H8.623V6.111c0-1.908 1.513-3.457 3.383-3.463z"
      fill="#231815"
    />
    <mask
      id="Locked_svg__a"
      maskUnits="userSpaceOnUse"
      x={3}
      y={1}
      width={18}
      height={23}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.014 9.707V6.112C17.014 3.29 14.772 1 12.005 1 9.24 1 6.996 3.289 6.996 6.112v3.595C4.74 9.875 2.994 11.796 3 14.105v5.497C3 22.032 4.93 24 7.309 24h9.382C19.071 24 21 22.031 21 19.602v-5.497c.006-2.305-1.733-4.225-3.986-4.398zM12.006 2.65c1.875 0 3.398 1.549 3.403 3.463v3.563H8.623V6.111c0-1.908 1.513-3.457 3.383-3.463z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#Locked_svg__a)">
      <path
        fill="url(#Locked_svg__paint0_radial)"
        d="M.823.905h23.294V25H.823z"
      />
    </g>
    <defs>
      <radialGradient
        id="Locked_svg__paint0_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(37.2683 0 0 38.55 -5.334 12.952)"
      >
        <stop offset={0.151} stopColor="#973FA5" />
        <stop offset={0.74} stopColor="#5937BC" />
        <stop offset={1} stopColor="#3F38A6" />
      </radialGradient>
    </defs>
  </svg>
)

export default SvgLocked
